import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { Message } from '../../Message/rn';
import { FONT_WEIGHT_REGULAR } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var TipMessage = function TipMessage(props) {
  var _props$styles, _props$styles2;
  if (!props.content) {
    return null;
  }
  var content = "<p class=\"tip-message-content\">".concat(props.content, "<p>");
  return /*#__PURE__*/React.createElement(Message, _extends({}, props, {
    styles: {
      containerStyle: _objectSpread(_objectSpread({}, styles['tip-message-container']), ((_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles.containerStyle) || {}),
      textStyle: _objectSpread(_objectSpread({}, styles['tip-message-text']), ((_props$styles2 = props.styles) === null || _props$styles2 === void 0 ? void 0 : _props$styles2.textStyle) || {})
    },
    className: "tip-message-text",
    content: content
  }));
};
var styles = CustomStyleSheet({
  'tip-message-container': {
    marginVertical: 0,
    marginHorizontal: 12,
    backgroundColor: '#ffffff',
    borderRadius: 4
  },
  'tip-message-text': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 10,
    paddingBottom: 10
  })
});